window.exports = {};

export default window.exports;
